import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Page } from "../components/Layout";
import { api, fmtDate } from "../lib/api";
import { usePoll } from "../lib/hooks";

const COLOR = { ERROR: "text-red-400", WARN: "text-amber-300", INFO: "text-neutral-300" };

export default function Log() {
  const [level, setLevel] = useState("");
  const [logs, setLogs] = useState([]);
  usePoll(() => api.get(`/logs?limit=300${level ? `&level=${level}` : ""}`).then((r) => setLogs(r.data)).catch(() => {}), 5000, [level]);
  return (
    <Page title="Log elaborazioni" subtitle="Eventi di acquisizione, elaborazione, revisione e pulizia. Le credenziali non vengono mai registrate." testid="log-page"
      actions={<Select value={level || "__all"} onValueChange={(v) => setLevel(v === "__all" ? "" : v)}>
        <SelectTrigger className="h-8 w-40 rounded-sm" data-testid="log-level-select"><SelectValue /></SelectTrigger>
        <SelectContent><SelectItem value="__all">Tutti i livelli</SelectItem><SelectItem value="INFO">INFO</SelectItem><SelectItem value="WARN">WARN</SelectItem><SelectItem value="ERROR">ERROR</SelectItem></SelectContent>
      </Select>}>
      <div className="bg-[#0A0A0A] rounded-sm p-4 font-mono text-[11px] max-h-[75vh] overflow-y-auto" data-testid="log-console">
        {logs.map((l) => (
          <div key={l.id} className={`${COLOR[l.level]} py-0.5`}>
            <span className="text-neutral-500">{fmtDate(l.created_at)}</span> [{l.level}] <span className="text-[#4D7CFF]">{l.component}</span> {l.message}
          </div>
        ))}
        {!logs.length && <div className="text-neutral-500">Nessun evento.</div>}
      </div>
    </Page>
  );
}
